import { faEye, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import { GetAllCustomerData } from 'pages/Componets/API_Modal/CustomerMasterAPIModal';
import React, { useRef, useState } from 'react'
import { Card } from 'react-bootstrap';
import AddItem from './components/itemMaster/AddItem';
import notistack from 'pages/Core/Notistack';
import PoCreationProcess from './components/itemMaster/PoCreationProcess';
import { data } from './components/itemMaster/index';
import ItemMasterViewDetails from './components/itemMaster/ItemMasterViewDetails';
import { getItemMasterList } from './components/itemMaster/services';
import { useNavigate } from 'react-router-dom';

const ItemMasterList = () => {
  const HasPermission = useHasPermission()
  const [addVendorOpen, setAddVendorOpen] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0);
  const [openDelete, setOpenDelete] = useState(false)
  const [isViewDetailOpen, setIsViewDetailOpen] = useState(false)
  const [viewDetailId, setViewDetailId] = useState<number | null>(null)
  const [selectedId, setSelectedId] = useState<number | null>(null)

  const reloadDataSource = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const dataSource = (): any | undefined => {
    return new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        try {
          const { searchValue, } = loadOptions;
          const parameterList = new URLSearchParams();
          const search = JSON.parse(JSON.stringify(loadOptions));
          for (const [key, value] of Object.entries(search)) {
            parameterList.append(key, JSON.stringify(value));
          }

          if (searchValue) {
            parameterList.append("search", searchValue);
          }

          const response = await getItemMasterList(parameterList);
          return response;
        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      },
    });
  };

  const selectedIdsRef = useRef<number[] | null>([]);

  const handleSelection = (selectedKeys: number[]) => {
    selectedIdsRef.current = selectedKeys;
  };

  const [poModalOpen, setPoModalOpen] = useState(false)
  const dataGridRef = useRef<any>(null);

  const handleButtonClick = () => {
    if (!Boolean(selectedIdsRef.current && selectedIdsRef.current.length > 0)) {
      return notistack.warning('Please select at least one product.')
    }
    setPoModalOpen(true)
  };


  const handlePOClose = () => {
    selectedIdsRef.current = null;
    setPoModalOpen(false);

    // Clear DataGrid selection
    dataGridRef.current?.instance?.clearSelection();
  };

  const navigate = useNavigate();



  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0" >Item Master</h5>
              {HasPermission("GoldRateMaster.Write") && <>
                <div className='d-flex justify-content-between align-items-end gap-2 '>
                  {/* <button
                    onClick={handleButtonClick}
                    className="btn btn-sm"
                    style={{ border: "1px solid #000" }}
                  >
                    PO Creation
                  </button> */}

                  <button className="btn btn-sm"
                    style={{ border: "1px solid #000" }}
                    type="button"
                    onClick={() => {
                      // setSelectedId(null)
                      // setAddVendorOpen(true)
                      navigate('/add-item')
                    }}
                  >
                    <i className="bi bi-plus-lg"></i> Add Item Details
                  </button>
                </div>

              </>
              }
            </Card.Header>
            <Card.Body>
              {HasPermission("Customer.Read") ? (
                <DataGrid
                  ref={dataGridRef}
                  dataSource={dataSource()}
                  remoteOperations={{ groupPaging: true }}
                  showRowLines={true}
                  keyExpr="id"
                  key={refreshKey}
                  showBorders={true}
                  onContentReady={(e) => {
                    const hasData = e.component.totalCount() > 0;
                    e.component.option("pager.visible", hasData);
                    e.component.option("paging.visible", hasData);
                  }}
                >
                  <Pager
                    showPageSizeSelector
                    allowedPageSizes={[10, 25, 50, 100]}
                    showNavigationButtons
                    displayMode="full"
                    showInfo
                  />
                  <Scrolling
                    mode="standard"
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                  />
                  <SearchPanel
                    visible={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Summary>
                    <TotalItem />
                  </Summary>
                  <Paging defaultPageSize={10} />

                  {(HasPermission("Customer.Write") ||
                    HasPermission("Customer.Delete")) && (
                      <Column
                        allowFiltering={false}
                        caption="Action"
                        width='15%'
                        cssClass="text-center"
                        cellRender={({ data }) => (
                          <div className="d-flex justify-content-center align-items-center gap-2">
                            <button
                              className='btn btn-sm action-btn'
                              title='View Details'
                              onClick={() => {
                                setIsViewDetailOpen(true)
                                setViewDetailId(data.id)
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} className="ml-2" />
                            </button>
                          </div>
                        )}
                      />
                    )}
                  <Column
                    dataField="id"
                    dataType="number"
                    sortOrder="desc"
                    width={150}

                    visible={false}
                  />
                  <Column
                    dataField="productName"
                    caption="Product Name"
                    width={150}
                    dataType="string"
                  />
                  <Column
                    dataField="styleNo"
                    caption="Style No"
                    width={150}
                    dataType="string"
                  />
                  <Column
                    dataField="materialType"
                    caption="Material Type"
                    width={150}
                    dataType="string"
                  />
                  <Column
                    dataField="metalColor"
                    caption="Metal Color"
                    width={150}
                    dataType="string"
                  />
                  <Column
                    dataField="category"
                    caption="Category"
                    width={150}
                    dataType="string"
                  />
                  <Column
                    dataField="subCategory"
                    caption="SubCategory"
                    width={150}
                    dataType="string"
                  />
                </DataGrid>
              ) : (
                null
              )}
            </Card.Body>
          </Card>
        </div>
      </div>

      {/* <AddItem
        reloadDataSource={reloadDataSource}
        selectedId={selectedId}
        onClose={() => {
          setSelectedId(null)
          setAddVendorOpen(false)
        }}
        isAddOpen={addVendorOpen} /> */}

      <PoCreationProcess
        isOpen={poModalOpen}
        selectedIds={selectedIdsRef.current}
        reloadDataSource={reloadDataSource}
        onClose={handlePOClose}
      />

      <ItemMasterViewDetails
        reloadDataSource={reloadDataSource}
        selectedId={viewDetailId}
        onClose={() => setIsViewDetailOpen(false)}
        isOpen={isViewDetailOpen}
      />
    </>
  )
}

export default ItemMasterList
